import { useRouter } from 'next/router';
import { useUser as useClerkUser } from '@clerk/nextjs';

import { plans } from '@data/plans';

import { useCurrentSubscriptionQuery } from '@api/hooks/useCurrentSubscriptionQuery';

import { useClerkAuth } from '@hooks/useClerkAuth';

import { SubscriptionCard } from './SubscriptionCard';

import styles from './Subscriptions.module.css';

/**
 * @param props
 * @param {string} [props.className]
 *
 * @returns {JSX.Element}
 */
export function Subscriptions({ className }) {
  const router = useRouter();

  const { data: clerkData } = useClerkAuth();
  const { clerkUserId } = clerkData;

  const { isLoaded: isClerkUserLoaded, user: clerkUser } = useClerkUser();
  const clerkUserEmail =
    isClerkUserLoaded && clerkUser
      ? clerkUser.emailAddresses[0]?.emailAddress ?? null
      : null;

  const { data: currentPlanData, loading: currentPlanDataLoading } =
    useCurrentSubscriptionQuery({ clerkUserId });

  const plansLoading = !clerkUserEmail || currentPlanDataLoading;

  /**
   * @param {string} checkoutLink
   * @returns {Promise<void>}
   */
  const handleSubscribe = async (checkoutLink) => {
    // Add gtag conversion tracker
    await router.push(checkoutLink);
  };

  return (
    <section className={className}>
      <ul className={styles.subscriptionCardsList}>
        {plans
          .filter((plan) => plan.visible !== false)
          .map((subscriptionPlan) => (
            <li
              key={subscriptionPlan.id}
              className={styles.subscriptionCardListItem}
            >
              <SubscriptionCard
                className="h-full"
                currentSubscriptionPlanType={
                  currentPlanData?.current_subscription
                }
                subscriptionPlan={subscriptionPlan}
                userEmail={clerkUserEmail}
                loading={plansLoading}
                onSubscribe={handleSubscribe}
              />
            </li>
          ))}
      </ul>
    </section>
  );
}
